/*
 * File: index.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: HOC for the dashboard service
 */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import DashboardHome from "./views/DashboardHome";

// flag for animating the dashboard cards
// we only want to animate them once and not on subsequent views
let didLoad = false;

const Index = ({ appStore, history }) => {
  useEffect(() => {
    appStore.setTitle("MacPractice");
    appStore.setRightNav();

    // wait 3 seconds then set didLoad so the animation has time to work
    setTimeout(() => {
      didLoad = true;
    }, 3000);
  });

  return <DashboardHome didLoad={didLoad} history={history} />;
};

Index.propTypes = {
  appStore: PropTypes.object,
  history: PropTypes.object.isRequired
};

export default Index;
